<h3>Synchronizations Quickbook</h3>
<div class="container-fluid" *ngIf="accessToken && companyDetails && synchronizationsPage">
  <div class="row">
    <div class="col-lg-4 mb-3">
      <label for="disabledTextInput" class="form-label">Dernière synchronization</label>
      <input type="text" id="disabledTextInput" class="form-control" placeholder="{{ lastSynchronization?.startTimestamp | date:'yyyy-MM-dd HH:mm:ss' }}">
    </div>
    <div class="col-lg-4 mb-3">
      <label for="disabledTextInput" class="form-label">Expiration du jeton Quickbook</label>
      <input type="text" id="disabledTextInput" class="form-control" placeholder="{{ accessToken.refreshTokenExpiration | date:'yyyy-MM-dd HH:mm:ss' }}">
    </div>

    <div class="col-lg-4 mb-3 text-center">
      <label for="disabledTextInput" class="form-label">
        &nbsp;
      </label>
      <div>
        <button 
          type="submit"
          (click)="getTokens()"
          class="btn btn-primary mr-3"
        >Rafraichir le jeton</button>

        <button 
          class="btn btn-primary"
          *ngIf="!isTokenExpired()"
          (click)="startNewSynchronization()"
        >Synchronizer</button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class='table table-sm table-bordered text-center'>
          <thead>
            <tr>
              <th>Démarrage</th>
              <th>Fin</th>
              <th>Statut</th>
              <th>Fournisseurs créés</th>
              <th>Fournisseurs importés</th>
              <th>Factures créées</th>
              <th>Factures importées</th>
              <th>Crédits créés</th>
              <th>Crédits importés</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let synchronization of synchronizationsPage.content">
              <td>{{ synchronization.startTimestamp | date:'yyyy-MM-dd HH:mm:ss'}}</td>
              <td>{{ synchronization.endTimestamp | date:'yyyy-MM-dd HH:mm:ss'}}</td>
              <td>
                <span class="badge badge-success" *ngIf="synchronization.endTimestamp && !synchronization.errorMessage">
                  Complété
                </span>
                <span 
                  class="badge badge-warning" 
                  *ngIf="!synchronization.endTimestamp && !synchronization.errorMessage"
                >
                  En cours
                </span>
                <button 
                  class="btn btn-sm btn-danger" 
                  *ngIf="synchronization.errorMessage" 
                  (click)="openErrorMessage(synchronization.errorDetails)"
                >
                  Erreur
                </button>
              </td>
              <td>{{ synchronization.vendorsCreated }}</td>
              <td>{{ synchronization.vendorsImported }}</td>
              <td>{{ synchronization.billsCreated }}</td>
              <td>{{ synchronization.billsImported }}</td>
              <td>{{ synchronization.creditsCreated }}</td>
              <td>{{ synchronization.creditsImported }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Erreur shopify</h4>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <pre>{{ errorToDisplay }}</pre>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close()">Fermer</button>
  </div>
</ng-template>